<template>
  <div class="help-change-main-container bg-white">
    <section v-if="!showResume">
      <help-select-change-header />
      <div
        class="help-change-items-list-container d-flex flex-column align-items-center py-3 px-3 px-sm-5 "
      >
        <changes-list :options="getChangeList" ref="changes" />
      </div>
      <div class="d-flex justify-content-center">
        <b-button @click="sendData" class="go-next-button text-uppercase my-3 mx-3">
          GO
        </b-button>
      </div>
    </section>
    <section v-else>
      <div class="px-3 py-2 d-flex">
        <span class="material-icons mr-3" @click="showResume = false">arrow_back</span>
        <p class="w-100 text-center text-uppercase">Problem Solving</p>
      </div>
      <help-resume
        :problemName="$route.query.userProblemName"
        :changesByCategory="$refs.changes.changesByCategory"
        :problemId="$route.query.userProblemId"
      />
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';
import { HelpSelectChangeHeader, complexItemsList as changesList } from '@/components/help';
import HelpResume from './HelpResume.vue';

export default {
  components: {
    changesList,
    HelpResume,
    HelpSelectChangeHeader,
  },
  data() {
    return {
      showResume: false,
    };
  },
  methods: {
    ...mapActions('help', ['FetchSkills', 'updateChangesByCategory']),
    async sendData() {
      try {
        this.showResume = true;
        const changesSelected = this.$refs.changes.items;
        this.updateChangesByCategory(this.$refs.changes.changesByCategory);
        await this.FetchSkills(changesSelected);
      } catch (error) {
        console.error(error);
      }
    },
  },
  computed: {
    ...mapGetters('help', ['getChangeList', 'getSkillList', 'getChangesByCategory']),
  },
  mounted() {
    if (Object.keys(this.getChangesByCategory).length) this.showResume = true;
  },
  beforeRouteEnter(to, from, next) {
    let causes = [];
    if (Array.isArray(to.query.causesBefore) || Array.isArray(to.query.causesAfter)) {
      let before = to.query.causesBefore.concat([]);
      causes = before.concat(to.query.causesAfter);
    } else {
      causes = [to.query.causesBefore, to.query.causesAfter];
    }
    Promise.all([store.dispatch('help/FetchChanges', causes)]).then(() => {
      next();
    });
  },
};
</script>
<style lang="scss">
.help-change-main-container {
  .material-icons {
    color: var(--color-main) !important;
  }
}
</style>
<style scoped>
.help-change-main-container {
  flex-direction: column;
}
.help-change-items-list-container {
  overflow: auto;
  flex: 1;
}
.go-next-button {
  border: 1px #1e90ff solid;
  border-radius: 4px;
  width: 100%;
  max-width: 400px;
  background-color: #ffffff;
  color: #1e90ff;
}
</style>
